<template>
    <a href="#" title="Valider ce point" @click="solveItem()">
        <i class="far fa-fw fa-square text-secondary"></i>
    </a>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../../dashboard/mixins/DataUpdater'

export default {
    name: 'SolvePendingPoint',

    mixins: [DataUpdater],

    props: {
        point: {},
    },

    methods: {
        async solveItem() {
            const form = {}
            form.status = 'SOL'
            try {
                await axios.put(`/pendingPoints/${this.point.id}/status`, form)
                this.filterData(this.point.id)
            } catch (error) {
                console.log(error)
            }
        },
    },

    computed: {
        ...mapState({
            pageName: (state) => state.browsing.pageName,
        }),
    },
}
</script>

<style scoped></style>
